import { Set, Utils } from '@everyboard/lib';
import { PlayerOrNone } from '../../jscaip/Player';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { TableUtils } from '../../jscaip/TableUtils';
import { GameState } from '../../jscaip/state/GameState';
import { PylosCoord } from './PylosCoord';
export class PylosState extends GameState {
    boards;
    static getLevelRange(z) {
        switch (z) {
            case 0: return [0, 1, 2, 3];
            case 1: return [0, 1, 2];
            default:
                Utils.expectToBe(z, 2);
                return [0, 1];
        }
    }
    constructor(boards, turn) {
        super(turn);
        this.boards = boards;
    }
    getPieceAt(coord) {
        return this.boards[coord.z][coord.y][coord.x];
    }
    applyLegalMove(move, increment = true) {
        const updateValues = [];
        updateValues.push({ coord: move.landingCoord, value: this.getCurrentPlayer() });
        if (move.startingCoord.isPresent()) {
            updateValues.push({ coord: move.startingCoord.get(), value: PlayerOrNone.NONE });
        }
        if (move.firstCapture.isPresent()) {
            updateValues.push({ coord: move.firstCapture.get(), value: PlayerOrNone.NONE });
        }
        if (move.secondCapture.isPresent()) {
            updateValues.push({ coord: move.secondCapture.get(), value: PlayerOrNone.NONE });
        }
        let turn;
        if (increment) {
            turn = this.turn + 1;
        }
        else {
            turn = this.turn;
        }
        return this.setBoardAtCoords(updateValues, turn);
    }
    setBoardAtCoords(coordValues, turn) {
        const newBoard = [
            TableUtils.copy(this.boards[0]),
            TableUtils.copy(this.boards[1]),
            TableUtils.copy(this.boards[2]),
            TableUtils.copy(this.boards[3]),
        ];
        for (const coordValue of coordValues) {
            const coord = coordValue.coord;
            const value = coordValue.value;
            newBoard[coord.z][coord.y][coord.x] = value;
        }
        return new PylosState(newBoard, turn);
    }
    isLandable(coord) {
        if (this.getPieceAt(coord).isPlayer()) {
            return false;
        }
        if (coord.z === 0)
            return true;
        const lowerPieces = coord.getLowerPieces();
        for (const lowerPiece of lowerPieces) {
            if (this.getPieceAt(lowerPiece).isNone()) {
                return false;
            }
        }
        return true;
    }
    isSupporting(coord) {
        if (coord.z === 3)
            return false;
        const higherPieces = coord.getHigherCoords();
        for (const higherPiece of higherPieces) {
            if (this.getPieceAt(higherPiece).isPlayer()) {
                return true;
            }
        }
        return false;
    }
    getPiecesRepartition() {
        const ownershipMap = PlayerNumberMap.of(0, 0);
        for (let z = 0; z < 3; z++) {
            for (let y = 0; y < (4 - z); y++) {
                for (let x = 0; x < (4 - z); x++) {
                    const c = new PylosCoord(x, y, z);
                    const v = this.getPieceAt(c);
                    if (v.isPlayer()) {
                        ownershipMap.add(v, 1);
                    }
                }
            }
        }
        return ownershipMap;
    }
    removePieceAt(coord) {
        const removeCoord = {
            coord,
            value: PlayerOrNone.NONE,
        };
        return this.setBoardAtCoords([removeCoord], this.turn);
    }
    dropCurrentPlayersPieceAt(coord) {
        const addedCoord = {
            coord,
            value: this.getCurrentPlayer(),
        };
        return this.setBoardAtCoords([addedCoord], this.turn);
    }
    getFreeToMoves() {
        const freeToMove = [];
        const currentPlayer = this.getCurrentPlayer();
        for (let z = 0; z <= 2; z++) {
            const levelRange = PylosState.getLevelRange(z);
            for (const y of levelRange) {
                for (const x of levelRange) {
                    const coord = new PylosCoord(x, y, z);
                    if (this.getPieceAt(coord).equals(currentPlayer) &&
                        this.isSupporting(coord) === false) {
                        freeToMove.push(coord);
                    }
                }
            }
        }
        return new Set(freeToMove);
    }
}
